import { render, staticRenderFns } from "./ed-verify-code-input.component.vue?vue&type=template&id=2cbf316f&scoped=true&"
import script from "./ed-verify-code-input.component.ts?vue&type=script&lang=ts&"
export * from "./ed-verify-code-input.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-verify-code-input.component.scss?vue&type=style&index=0&id=2cbf316f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cbf316f",
  null
  
)

export default component.exports